import { styled } from '@linaria/react';
import { RangeSizesType } from '../../../../../types/Sizes';
import { cssTheme } from '../../../../themes';
interface PropsType {
  /** The size of the bottom padding. Only spacing sizes from the theme are accepted */
  paddingBottom?: RangeSizesType;

  /** The size of the left padding. Only spacing sizes from the theme are accepted */
  paddingLeft?: RangeSizesType;

  /** The size of the right padding. Only spacing sizes from the theme are accepted */
  paddingRight?: RangeSizesType;

  /** The size of the padding for all sides. Only spacing sizes from the theme are accepted. Each side will be overwritten if it is passed separately */
  padding?: RangeSizesType;

  /** The size of the top padding. Only spacing sizes from the theme are accepted */
  paddingTop?: RangeSizesType;

  /** The size of the horizontal padding. Only spacing sizes from the theme are accepted */
  paddingX?: RangeSizesType;

  /** The size of the vertical padding. Only spacing sizes from the theme are accepted */
  paddingY?: RangeSizesType;
}

// Helper function to determine padding
const resolvePadding = (specificPadding: RangeSizesType | undefined, axisPadding: RangeSizesType | undefined, defaultPadding: RangeSizesType): string => {
  return cssTheme.layout.spacing[specificPadding || axisPadding || defaultPadding];
};
const _exp = /*#__PURE__*/() => ({
  paddingBottom,
  paddingY,
  padding = 's000'
}) => resolvePadding(paddingBottom, paddingY, padding);
const _exp2 = /*#__PURE__*/() => ({
  paddingLeft,
  paddingX,
  padding = 's000'
}) => resolvePadding(paddingLeft, paddingX, padding);
const _exp3 = /*#__PURE__*/() => ({
  paddingRight,
  paddingX,
  padding = 's000'
}) => resolvePadding(paddingRight, paddingX, padding);
const _exp4 = /*#__PURE__*/() => ({
  paddingTop,
  paddingY,
  padding = 's000'
}) => resolvePadding(paddingTop, paddingY, padding);
export const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1cmzxsv",
  propsAsIs: false,
  vars: {
    "c1cmzxsv-0": [_exp()],
    "c1cmzxsv-1": [_exp2()],
    "c1cmzxsv-2": [_exp3()],
    "c1cmzxsv-3": [_exp4()]
  }
});
export default ContentWrapper;

require("./index.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.ts");